import * as React from "react";
import { IconButton, Menu, MenuItem } from "@material-ui/core";

import { MdOutlineMoreVert } from "react-icons/md";

export default function ActionMenu(props) {
  const { options } = props;
  const menuId = React.useId();
  const buttonId = `${menuId}-button`;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const visibleOptions = options.filter((option) => !option?.hide);
  const hasIcons = visibleOptions.some((option) => option.icon);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        className="action-menu-trigger"
        aria-label="Row actions"
        id={buttonId}
        aria-controls={open ? menuId : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="menu"
        onClick={handleClick}
      >
        <MdOutlineMoreVert />
      </IconButton>
      <Menu
        id={menuId}
        MenuListProps={{
          "aria-labelledby": buttonId,
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          className: "compact-popover action-menu-paper",
        }}
      >
        {visibleOptions.map((option) => (
          <MenuItem
            key={option.label}
            onClick={() => {
              option.onClick(option.value);
              handleClose();
            }}
          >
            {hasIcons && (
              <span className="action-menu-icon" aria-hidden="true">{option.icon}</span>
            )}
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
